module.exports = __webpack_public_path__ + "7e301051cadd2dcbfb945f803636d440.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/expression-rage.png
// module id = 2320
// module chunks = 0